import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import useQueryRequestParams from '../../../../hooks/useQueryRequestParams';
import envVars from '../../../../constants/envVars';
const useGenerateWebUIPassword = () => {
    const params = useQueryRequestParams();
    return useMutation({
        mutationFn: async (device_id) => {
            const response = await axios.post(`${envVars.API_CLOUD_HOSTNAME}backoffice/device-webui-password/`, { id: device_id }, params);
            return response.data;
        }
    });
};
export default useGenerateWebUIPassword;
